// extracted by mini-css-extract-plugin
export default {"getOutline":"WaterMarkProbrain_getOutline__YZYEM","WaterMarkProbrain":"WaterMarkProbrain_WaterMarkProbrain__8g5ER"};